<template>
  <div class="bg-gray-800 text-white p-5 mt-[40%] mx-auto rounded-xl shadow-lg ">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "VCard"
}
</script>

<style scoped>

</style>